import {useLocation} from "react-router-dom";
import {getI18n, useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigateTo} from "../../../hooks/useNavigateTo";
import border from './border.png';
import cookies from "../../../utils/cookies";
import {useMemo} from "react";

const menus = [
  {
    name: '首页',
    icon: 'home',
    path: '/',
  },
  {
    name: '分类',
    icon: 'menus',
    path: '/goodsList'
  },
  {
    name: '购物车',
    icon: 'shop',
    path: '/cart'
  },
  {
    name: '我的',
    icon: 'user',
    path: '/my'
  },
];

export default function FooterMall9({ noTabs, noFooter, style, theme = 'white' }) {
  const navigateTo = useNavigateTo();
  const location = useLocation();
  const state = useSelector(state => state);
  const { t } = useTranslation();
  const lang = getI18n().language
  
  const agentInfo = useMemo(() => {
    return cookies.getAgentInfo() || {};
  }, []);
  
  const navs = [
    {
      name: '首页',
      path: '/'
    },
    {
      name: '预约服务',
      path: '/bookingList'
    },
    {
      name: '资讯分享',
      path: '/news'
    },
    {
      name: '产品分类',
      path: '/goodsList'
    },
  ];
  
  const navBar = useMemo(() => {
    if (agentInfo.navBar) {
      let res = JSON.parse(agentInfo.navBar);
      res = res.filter(item => item.state);
      
      let hasProduct = res.find(item => item.path === '/goodsList');
      
      if (!hasProduct) {
        res = res.filter(item => item.path !== '/');
      }
      
      return res.sort((a, b) => a.sort - b.sort);
    }
    return navs;
  }, [agentInfo]);
  
  return (
    <>
      {
        !noFooter &&
        <footer className="overflow-hidden relative pt-[120px] mdmax:hidden"
                style={style}>
          <img src={border} className="absolute top-0" draggable={false}/>
          <div className="container-center mobile flex py-[50px] relative">
            <div className="flex-none pr-[15%]">
              <h5 className="text-[26px] font-bold pb-[40px]">{agentInfo.agentName}</h5>
              <p className="mb-[12px]">{agentInfo.mobileno}</p>
              <p className="mb-[12px]">{lang === "en" ? agentInfo.enAddress : agentInfo.address}</p>
              <p className="mb-[20px]">
                <a onClick={() => navigateTo('/agreement?type=privacy')}
                   className="link center inline-block pr-[20px]">{t('隐私条款')}</a>
                
                <a onClick={() => navigateTo('/agreement?type=reg')}
                   className="link center inline-block pr-[20px]">{t('注册协议')}</a>

                <a onClick={() => navigateTo('/agreement?type=con')}
                   className="link center inline-block pr-[20px]">{t('条件和条款')}</a>
              </p>
              <p>
                {
                  agentInfo.detailWhatsappUrl
                  && <a href={agentInfo.detailWhatsappUrl}
                        target="_blank"
                        className="mr-[20px]">
                    <i className="iconfont text-[20px] icon-whats"/>
                  </a>
                }
                
                {
                  agentInfo.detailFbUrl
                  && <a href={agentInfo.detailFbUrl}
                        target="_blank"
                        className="mr-[20px]">
                    <i className="iconfont text-[20px] icon-facebook"/>
                  </a>
                }
                
                {
                  agentInfo.detailTwitterUrl
                  && <a href={agentInfo.detailTwitterUrl}
                        target="_blank"
                        className="mr-[20px]">
                    <i className="iconfont text-[20px] icon-twitter"/>
                  </a>
                }
                
                {
                  agentInfo.detailLinkinUrl
                  && <a href={agentInfo.detailLinkinUrl}
                        target="_blank"
                        className="mr-[20px]">
                    <i className="iconfont text-[20px] icon-linkedin1"/>
                  </a>
                }
                
                {
                  agentInfo.detailPinterestUrl
                  && <a href={agentInfo.detailPinterestUrl}
                        target="_blank"
                        className="mr-[20px]">
                    <i className="iconfont text-[20px] icon-pinterestpinterest30"/>
                  </a>
                }
              </p>
            </div>
            <div className="flex-1 flex justify-center text-center relative h-[24px]">
              {
                navBar.map((item, i) => (
                  <a onClick={() => navigateTo(item.path)}
                     key={i}
                     className="cursor-pointer pl-[60px] font-bold text-right">
                    {lang === 'en' ? item.nameEN : item.name}
                  </a>
                ))
              }
            </div>
          </div>
          <div className="py-[28px] text-center text-[#666]"
               dangerouslySetInnerHTML={{ __html: agentInfo.bottomInfo }}>
          
          </div>
        </footer>
      }
      {
        !noTabs && agentInfo.isProduct !== '0'
        && <div className={`flex fixed w-[100%] z-20 border-t mb-fixed-bottom border-[#efefef] bottom-0 left-0 md:hidden ${theme === 'black' ? 'bg-[#2e2e2e] border-[#444]' : 'bg-white'}`}>
          {
            menus.map((item, i) => {
              let iconColor = item.path === location.pathname ? 'text-[#333]' : 'text-[#999]';
              if (theme && theme === 'black') {
                iconColor = iconColor === 'text-[#333]' ? 'text-[#eee]' : 'text-[#999]';
              }
              return (
                <div key={i}
                     onClick={() => navigateTo(item.path, { replace: true })}
                     className={`relative pt-[2px] pb-[5px] flex-1 flex-col flex text-center text-[12px] ${iconColor}`}>
                  <i className={`iconfont text-[17px] icon-${item.icon} ${iconColor}`}></i>
                  {t(item.name)}
                  {
                    state.cartCount > 0 && item.path === '/cart' &&
                    <span className="absolute right-[50%] bg-[#f5222d] inline-block
                                   w-[17px] h-[17px] text-[12px] rounded-full text-white"
                          style={{ transform: 'translateX(24px)' }}>
                  {state.cartCount}
                </span>
                  }
                </div>
              );
            })
          }
        </div>
      }
    </>
  );
}
